import { useQuery } from "@tanstack/react-query";
import { useApi } from "hooks/useApi";
import { useProduct } from "contexts/ProductContext";

export const useAmplifyAPlusContent = () => {
  const api = useApi();
  const { product } = useProduct();
  const productId = product?.id;

  return useQuery({
    queryKey: ["product-amplify-a-plus-content", productId],
    queryFn: () => api.products.getAmplifyAPlusContent(productId!),
    enabled: !!productId,
  });
};
